module.exports = __webpack_public_path__ + "static/img_9876_dpp_optimized-59cbe2f814db76289649755c266f3440.jpg";